import BaseForm from '@kakadu-dev/base-frontend-helpers/forms/BaseForm';
import { Category } from "../../models/Categories";
import { DispatchSelector, StateSelector } from "../../modules/selectors";
/**
 * Categories form
 */

export class CategoriesForm extends BaseForm {
  constructor(...args) {
    super(...args);
    this.fields = [{
      label: 'Название',
      name: 'title'
    }, {
      label: 'Alias',
      name: 'alias'
    }, {
      label: 'Отображается',
      name: 'isVisible',
      type: BaseForm.TYPES.TOGGLE
    }, {
      label: 'Уровень',
      name: 'level',
      type: BaseForm.TYPES.DROPDOWN,
      props: {
        common: {
          data: BaseForm.getDropdownOptions(Category.levelsTitle)
        }
      }
    }];
    this.dispatchCreateForm = DispatchSelector.categories.create;
    this.dispatchUpdateForm = DispatchSelector.categories.update;
    this.responseCreateState = StateSelector.categories.create;
    this.responseUpdateState = StateSelector.categories.update;
  }

}